import { useZoneManager } from './useZoneManager'
import { useCallback } from 'react'

export function useURLBuilder() {
  const { buildZoneUrl } = useZoneManager()

  const getProjectPageUrl = useCallback((projectId: string | number, isGlobal?: boolean) => {
    return isGlobal ? `/globalhub/projects/${projectId}` : buildZoneUrl(`projects/${projectId}`)
  }, [buildZoneUrl])

  return { getProjectPageUrl }
}
